export const OptionsArray: string[] = [
  'Anaesthesiologist',
  'Cardiac Anaesthesiologist',
  'General physician',
  'Ayurvedic General Physician',
  'Homeopathic Physician',
  'Pathologist',
  'Radiologist',
  'Unani General Practitioner',
  'Gynecologist (Non surgical)',
  'Gynecologist surgeon',
  'Neonatologist',
  'Paediatric Allergologist',
  'Paediatric Cardiologist',
  'Paediatric Endocrinologist',
  'Paediatric Gastroenterologist/Hepatologist',
  'Paediatric Haematologist and Oncologist',
  'Paediatric Infectious Disease Specialist',
  'Paediatric Nephrologist',
  'Paediatric Respiratory Medicine Specialist',
  'Paediatric Rheumatologist',
  'Paediatrician (Non surgical)',
  'Cosmetic surgeon',
  'Plastic surgeon',
  'Adolescent Medicine Specialist',
  'Allergeologist and Immunotherapist',
  'Biochemist Specialist',
  'Cardiac Medicine and Internal Medicine',
  'Cardiologist',
  'Child and Adolescent Psychiatrist',
  'Clinical Neurophysiologist',
  'Critical care specialist',
  'Dermato-Venereologist',
  'Dermatologist',
  'Diabetologist',
  'Echo-Cardiologist',
  'Endocrinologist',
  'Eye Specialist/Opthalmologist',
  'Family Medicine and Emergency Medicine Specialist',
  'Gastroenterologist',
  'Geriatric Specialist',
  'Haematologist',
  'Hospice and Palliative Medicine',
  'Immunohematology and Blood Transfusion Specialist (IHBT)',
  'Infectious Disease Specialist',
  'Interventional Cardiologist',
  'Interventional Neuro Radiologist',
  'Interventional Pulmonologist',
  'Interventional Radiologist',
  'Leprologist',
  'Medical Oncologist',
  'Neuro Medicine Specialist',
  'Neurologist',
  'Neuropsychiatrist',
  'Neuroradiologist',
  'Nuclear Medicine Specialist',
  'Occupational Medicine Specialist',
  'Otorhinolaryngologist',
  'Pain Medicine Specialist',
  'Pharmacologist',
  'Physical Medicine and Rehabilitation',
  'Podiatric Medicine',
  'Pulmonologist',
  'Radio Oncologist',
  'Radiotherapist',
  'Respiratory Medicine',
  'Rheumatologist',
  'Sonologist',
  'Tropical Medicine Specialist',
  'Vascular Medicine Specialist',
  'Nephrologist',
  'Psychiatrist',
  'Dental Surgeon',
  'General Surgeon',
  'Orthopaedic Surgeon',
  'Bariatric Surgeon',
  'Bone marrow Surgeon',
  'Breast Surgeon',
  'Cardiac Surgeon',
  'Cardio surgeon',
  'Cardiothoracic Surgeon/Cardiothoracic and Vascular Surgeon',
  'E.N.T Specialist/E.N.T. Surgeon (Ear, Nose, Throat)',
  'Endodontist',
  'Endoscopic Surgeon',
  'Eye Surgeon/Ophthalmic Surgeon',
  'Gastroenterologist and Hepatologist/Gastro Surgeon',
  'Glaucoma Surgeon',
  'Head and Neck Surgeon',
  'Kidney Surgeon',
  'Laparoscopic Surgeon',
  'Nephro Surgeon',
  'Neurosurgeon',
  'Onco Surgeon',
  'Orthodontist',
  'Paedodontist',
  'Pediatric surgeon',
  'Periodontist and Implantologist',
  'Prosthodontist',
  'Urologist/Urosurgeon',
  'Vascular Surgeon',
  'Vitreo Retinal Surgeon',
  'Oral and Maxillofacial Surgeon',
];
